import { render, staticRenderFns } from "./PointTransactionsTable.vue?vue&type=template&id=0ec04d5b&"
import script from "./PointTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./PointTransactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports